import { Server, contentClient } from '@wajeez-web/core/api-base';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getAllReaderHighlightsForContainerId: ApiMethod<
  string | undefined,
  Server.HighlightOutput[]
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Highlights_Client(
      undefined,
      contentClient
    );
    const response = await client.highlights_byContainerId_get_V1(undefined, data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const createNewHighlight: ApiMethod<
  Server.CreateHighlightInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Highlights_Client(
      undefined,
      contentClient
    );
    const response = await client.highlights_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const deleteHighlight: ApiMethod<number | undefined, void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Highlights_Client(
      undefined,
      contentClient
    );
    const response = await client.highlights_delete_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};
